import $ from "jquery";

let context;

function setAddress(event) {
    event.preventDefault();
    const select = $(event.currentTarget);
    const form = select.parents('[data-checkout-address]');
    const value = select.val();
    // if there isn't a value, un-set the values
    if (!value) {
        form.find('input[name="Company"]').val('');
        form.find('input[name="Address1"]').val('');
        form.find('input[name="Address2"]').val('');
        form.find('input[name="Address3"]').val('');
        form.find('input[name="City"]').val('');
        form.find('input[name="County"]').val('');
        return false;
    }

    const key = select.data('loqate-key');

    $.post('https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws', {
        Key: key,
        Id: value,
    }, function (data) {
        var match = data.Items[0];
        if (!match) {
            return;
        }
        
        form.find('input[name="Company"]').val(match.Company);
        form.find('input[name="Address1"]').val(match.Line1);
        form.find('input[name="Address2"]').val(match.Line2);
        form.find('input[name="Address3"]').val(match.Line3);
        form.find('input[name="City"]').val(match.City);
        form.find('input[name="County"]').val(match.Province);
        
    });
}

export function initCheckoutPostcode() {
    context = $('[data-checkout-address]');

    $(document).on("change", "[data-checkout-address] [data-set-checkout-address]", setAddress)

}